import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "creatives" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "ds-caption ds-caption--bold ds-caption--size_xl" }, "Добавление домена", -1)
const _hoisted_3 = { class: "g-row g-row--appearance_spaced g-row--space_md g-row--align_center g-row--justify_center ds-space_mt ds-space_mt--4" }
const _hoisted_4 = { class: "g-cell g-cols g-cols--12-xs" }
const _hoisted_5 = { class: "g-cell g-cols g-cols--12-xs" }
const _hoisted_6 = { class: "g-cell g-cols g-cols--12-xs" }
const _hoisted_7 = { class: "g-cell g-cols g-cols--12-xs" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "button__icon" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "button__text" }, "Сохранить", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_d_control_input = _resolveComponent("d-control-input")!
  const _component_i_plus = _resolveComponent("i-plus")!
  const _component_VeeForm = _resolveComponent("VeeForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_VeeForm, { onSubmit: $setup.request }, {
      default: _withCtx(({ errors }) => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_d_control_input, {
              name: "domains",
              type: "text",
              staticLabel: _ctx.$t('Укажите домен'),
              modelValue: $setup.formData.domains,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.formData.domains) = $event)),
              rules: "required|url"
            }, null, 8, ["staticLabel", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_d_control_input, {
              component: "d-control-multiselect",
              staticLabel: _ctx.$t('Баер'),
              options: $setup.buyersList,
              placeholder: _ctx.$t('Баер'),
              modelValue: $setup.formData.buyer,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => (($setup.formData.buyer) = $event)),
                _cache[2] || (_cache[2] = e => $setup.onChangeBuyer(e))
              ],
              value: $setup.formData.buyer,
              name: "buyer",
              "track-by": "id",
              "label-by": "name",
              "allow-empty": false,
              onClearMultiselect: $setup.onClearBuyer
            }, null, 8, ["staticLabel", "options", "placeholder", "modelValue", "value"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_d_control_input, {
              component: "d-control-multiselect",
              staticLabel: _ctx.$t('TDS'),
              options: $setup.tdsList,
              placeholder: _ctx.$t('TDS'),
              modelValue: $setup.formData.tds,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.formData.tds) = $event)),
              value: $setup.formData.tds,
              name: "tds",
              "track-by": "id",
              "label-by": "name",
              "allow-empty": false,
              rules: $setup.requiredTds,
              onClearMultiselect: _cache[4] || (_cache[4] = ($event: any) => ($setup.formData.tds = null))
            }, null, 8, ["staticLabel", "options", "placeholder", "modelValue", "value", "rules"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              class: "button",
              type: "submit",
              disabled: _ctx.isLoad
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_i_plus)
              ]),
              _hoisted_10
            ], 8, _hoisted_8)
          ])
        ])
      ]),
      _: 1
    })
  ]))
}